<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['edit-billing-head-title']"
    :description="propsdata[0]['translation']['edit-billing-head-description']"
/>

        <div v-if="loading" style="margin-top: 150px;">
            <lottie-player src="https://qr.io/lottie/qr-loading.json" background="transparent" speed="1" style="width: 230px; height: 230px; margin: 0 auto;" loop autoplay></lottie-player>
        </div>

        <div v-if="!loading" class="container pt-7 mb-3">
            <h1 style="text-align: center;">{{propsdata[0]['translation']['edit-billing-title']}}</h1>
            <br>
            <div v-if="!team_member_warning" class="card border-light shadow-soft mb-5" style="max-width: 800px;margin: 0 auto;">
                <div class="card-body p-3 p-md-4">
                    <div>
                        <div class="col-12 p-0">
                            <div class="form-group">
                                <label class="form-label text-dark">{{propsdata[0]['translation']['edit-billing-client-name']}} <span class="text-danger">*</span></label>
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-user-alt"></i></span>
                                    </div>
                                    <input v-model="clientname" name="clientname" class="form-control pl-2" placeholder="eg. John Doe" type="text">
                                </div>
                                <span v-if="clientname === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">{{propsdata[0]['translation']['edit-billing-required-field']}}</span>
                            </div>
                        </div>
                        <div class="col-12 p-0">
                            <div class="form-group">
                                <label class="form-label text-dark">{{propsdata[0]['translation']['edit-billing-street-address']}} <span class="text-danger">*</span></label>
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-map-marker-alt"></i></span>
                                    </div>
                                    <input v-model="streetaddress" name="address" class="form-control pl-2" placeholder="eg. One Infinite Loop" type="address">
                                </div>
                                <span v-if="streetaddress === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">{{propsdata[0]['translation']['edit-billing-required-field']}}</span>
                            </div>
                        </div>
                        <div class="col-12 p-0">
                            <div class="form-group">
                                <label class="form-label text-dark">{{propsdata[0]['translation']['edit-billing-city-state-country']}} <span class="text-danger">*</span></label>
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-map-marker-alt"></i></span>
                                    </div>
                                    <input v-model="location" name="location" class="form-control pl-2" placeholder="eg. Cupertino, CA, United States" type="text">
                                </div>
                                <span v-if="location === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">{{propsdata[0]['translation']['edit-billing-required-field']}}</span>
                            </div>
                        </div>
                        <div class="col-12 p-0">
                            <div class="form-group">
                                <label class="form-label text-dark">{{propsdata[0]['translation']['edit-billing-zip-code']}} <span class="text-danger">*</span></label>
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-map-pin"></i></span>
                                    </div>
                                    <input v-model="zipcode" name="zip" class="form-control pl-2" placeholder="eg. 95014" type="text">
                                </div>
                                <span v-if="zipcode === '' && required" class="small" style="color: rgb(237, 80, 79); visibility: visible; position: relative;bottom: 15px;">{{propsdata[0]['translation']['edit-billing-required-field']}}</span>
                            </div>
                        </div>
                        <div class="col-12 p-0">
                            <div class="form-group">
                                <label class="form-label text-dark">{{propsdata[0]['translation']['edit-billing-vat-taxid']}} <span class="text-gray">({{propsdata[0]['translation']['edit-billing-optional']}})</span></label>
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-file"></i></span>
                                    </div>
                                    <input v-model="vat_taxid" name="text" class="form-control pl-2" placeholder="eg. xxxxxxxxx" type="text">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 p-0">
                            <div class="form-group">
                                <label class="form-label text-dark">{{propsdata[0]['translation']['edit-billing-extra-info']}} <span class="text-gray">({{propsdata[0]['translation']['edit-billing-optional']}})</span></label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-plus"></i></span>
                                    </div>
                                    <textarea v-model="extra_info" name="text" class="form-control pl-2" :placeholder="propsdata[0]['translation']['edit-billing-extra-info-placeholder']"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" style="margin: 0 auto;">
                            <button v-if="!loading_edit" @click="guardarbilling" class="btn btn-primary mt-4 animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>{{propsdata[0]['translation']['edit-billing-save']}}</button>
                            <button v-if="loading_edit" class="btn btn-primary mt-4 animate-up-2"><span class="mr-2"><i class="fas fa-spinner"></i></span>{{propsdata[0]['translation']['edit-billing-loading']}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="team_member_warning">
                <h4 class="mb-0">{{team_member_warning}}.</h4>
            </div>
        </div>
  
    </div>
</template>

<script>
    export default {
        props:['propsdata'],
        data() {
            return {
                loading: true,
                loading_edit: false,
                clientname: '',
                streetaddress: '',
                location: '',
                zipcode: '',
                vat_taxid: '',
                extra_info: '',
                required: false,
                team_member_warning: false
            };
        },
        methods: {
            guardarbilling(){
                this.loading_edit = true;
                axios.post('/dashboard/edit-billing.php', {
                    clientname: this.clientname,
                    streetaddress: this.streetaddress,
                    location: this.location,
                    zipcode: this.zipcode,
                    vat_taxid: this.vat_taxid,
                    extra_info: this.extra_info
                })
                .then(response => {
                    if(response.data == 'required'){
                        this.required = true;
                    }
                    else{
                        this.required = false;
                        this.$router.push('/dashboard/billing');
                    }
                    this.loading_edit = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
        mounted() {
            this.$emit('updatepath');
            //BILLING
            axios.post('/dashboard/cargar-billing.php', {
            })
            .then(response => {
                if(response.data.includes("You cannot access billing information because you are a team member. Please contact the account owner at")){
                    this.team_member_warning = response.data;
                }
                else{
                    this.clientname = response.data[0].clientname;
                    this.streetaddress = response.data[0].streetaddress;
                    this.location = response.data[0].location;
                    this.zipcode = response.data[0].zipcode;
                    this.vat_taxid = response.data[0].vat_taxid;
                    this.extra_info = response.data[0].extra_info;
                }
                this.loading = false;
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    };
</script>



// WEBPACK FOOTER //
// src/edit-billing.vue